import styled from 'styled-components'

export const BannerItemContainer = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * {
    width: 50%;
  }

  @media only screen and (max-width: 700px) {
    display: block;

    & > * {
      width: 100%;
    }
  }
`

export const BannerTextContainer = styled.div`
  max-width: ${({ single }) => (single ? '50%' : '45%')};

  h2 {
    font-size: 46px;
    font-weight: 800;
    line-height: 56px;
    color: var(--blue11);
    margin-bottom: 2rem;
  }

  p {
    font-size: 18px;
    line-height: 26px;
    color: var(--grey2);
    margin-bottom: 2rem;
    max-width: ${({ single }) => (single ? '80%' : '100%')};
  }

  a {
    background-color: var(--orange5);
    font-weight: 600 !important;
    color: var(--light);

    &:hover {
      background-color: var(--orange4);
    }
  }

  @media only screen and (max-width: 1050px) {
    max-width: 100%;

    h2 {
      font-size: 32px;
      line-height: 39px;
    }

    p {
      font-size: 16px;
      max-width: 100%;
    }
  }

  @media only screen and (max-width: 700px) {
    text-align: center;

    h2 {
      font-size: 24px;
      line-height: 29px;
    }

    a,
    button {
      max-width: 100% !important;
      width: 100%;
      margin-bottom: 3rem;
    }
  }
`

export const BannerImgContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  img {
    position: relative;
    margin: 0 auto;
    z-index: 1;

    &:not(.decorative) {
      max-width: 100%;
    }

    @media only screen and (max-width: 1050px) {
      &:not(.decorative) {
        width: 100%;
      }
    }
  }
`
